export const useFuncionario = () => {
  const useBase = useBaseStore('/gerencial/funcionario')
  return {
    ...useBase
  }
}
